import { Role } from '@/core/components/auth/auth.types'
import { LoadingList } from '@/core/components/LoadingList'
import { resellerByIdQueryOptions } from '@/core/components/resellers/resellerQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/resellers/$resellerId/edit/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role !== Role.Internal) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { resellerId } }) => {
    return queryClient.ensureQueryData(
      resellerByIdQueryOptions(auth.token!, resellerId)
    )
  },
  pendingComponent: LoadingList,
})
